import diagnoseAlgorithm from "../clinical-algorithm/diagnose/diagnoseAlgorithm";
import therapieempfehlungAlgorithm from "../clinical-algorithm/therapie/therapieempfehlungAlgorithm";
import readRuleSetForDiagnose from "../clinical-algorithm/diagnose/readRuleSetForDiagnose";
import diagnoseConfiguration from "../clinical-algorithm/diagnose/Stage3_Diagnostik.csv"
import therapieConfiguration from "../clinical-algorithm/therapie/Stage4_Medication.csv"

/**
 * Used to observe changes in the CDSS-Document to react to them by determining e.g. which tabs can be navigated to
 * (e.g. when adding a technischeUntersuchung, diagnose has to be confirmed again before the Therapie-Tab can be
 * navigated to).
 * Also, if you e.g. change the diagnosis, the selectedMedication also has to be reset.
 */
let __store = null
let __unsubscribeHnd = null

function extractDocumentPartFromMutationType(mutationType) {
    const splitPath = mutationType.split('/')
    return splitPath[splitPath.length - 2]
}

function extractNameOfAccessor(mutationType) {
    const splitPath = mutationType.split('/')
    return splitPath[splitPath.length - 1]
}

function recheckWhatShouldBeReachable() {
    if (__store) {
        const anfaelle = __store.getters['cdss/anfallsanamnese/anfaelle']
        const bestaetigteDiagnose = __store.getters['cdss/diagnosestellung/bestaetigteDiagnose']
        const diagnoseConfirmed = __store.getters['cdss/diagnosestellung/diagnoseConfirmed']
        if (anfaelle && anfaelle.length > 0) {
            __store.commit('cdss/setDiagnosestellungReachable', true)
        } else {
            __store.commit('cdss/setDiagnosestellungReachable', false)
        }

        if (bestaetigteDiagnose && diagnoseConfirmed) {
            __store.commit('cdss/setTherapieReachable', true)
        } else {
            __store.commit('cdss/setTherapieReachable', false)
        }
    }
}

/**
 * This function is triggered every time something is changed in the vuex-store
 * @param mutation The mutation that is called to invoke the change
 */
function onChange(mutation) {
    // -> The data of which "tab" is changed
    const modifiedPart = extractDocumentPartFromMutationType(mutation.type)

    // Depending on whether anfall, tu, diagnosis or therapy is changed, something differently is done.
    switch (modifiedPart) {
        case 'anfallsanamnese':
        case 'technischeUntersuchungen': {
            __store.commit('cdss/setTherapieReachable', false)
            __store.commit('cdss/diagnosestellung/setDiagnoseConfirmed', false)
            __store.commit('cdss/diagnosestellung/setVorgeschlageneDiagnose', 'not set yet')
            __store.commit('cdss/diagnosestellung/setBestaetigteDiagnose', 'not set yet')
            recheckWhatShouldBeReachable()
            inferAndCommitNewDiagnosis()
            break
        }
        case 'diagnosestellung': {
            const usedAccessor = extractNameOfAccessor(mutation.type)
            if (usedAccessor === 'setDiagnoseConfirmed' && mutation.payload || usedAccessor === 'setPatientIsPregnantSelected' && mutation.payload) {
                __store.commit('cdss/setTherapieReachable', true)
                inferAndCommitNewTherapie()
            } else {
                __store.commit('cdss/setTherapieReachable', false)
            }
            break
        }
    }
}

function inferAndCommitNewDiagnosis() {
    const theVorgeschlageneDiagnose = diagnoseAlgorithm.inferDiagnose(
        __store.getters['cdss/anfallsanamnese/anfaelle'],
        __store.getters['cdss/technischeUntersuchungen/untersuchungen'],
        __store.getters['cdss/patient'].birthDate,
        readRuleSetForDiagnose(diagnoseConfiguration)
    );
    __store.commit("cdss/diagnosestellung/setVorgeschlageneDiagnose", theVorgeschlageneDiagnose)
}

function inferAndCommitNewTherapie() {
    const arzneivorschlaege = therapieempfehlungAlgorithm.inferTherapieempfehlung(__store.getters['cdss/diagnosestellung/bestaetigteDiagnose'], __store.getters['cdss/patient'], __store.getters['cdss/diagnosestellung/patientIsPregnant'], therapieConfiguration);
    __store.commit("cdss/therapie/setArzneimittelvorschlaege", arzneivorschlaege)
}

function reinferDiagnoseAndTherapy() {
    inferAndCommitNewDiagnosis()
    inferAndCommitNewTherapie()
}

/**
 * Can be used to register a vuex-store to this observer. The observer will then react to change accordingly
 * (e.g. disable the therapy-tab if you change something that requires re-confirming the diagnosis)
 * @param store The vuex-store that should be registered with this observer
 */
function observeStore(store) {
    __store = store

    recheckWhatShouldBeReachable()
    inferAndCommitNewDiagnosis()

    // -> The onChange function is called everytime something is written to the vuex-store
    __unsubscribeHnd = __store.subscribe(onChange)
}

function unsubscribe() {
    __unsubscribeHnd()
}

export default observeStore
export {recheckWhatShouldBeReachable, unsubscribe, reinferDiagnoseAndTherapy, inferAndCommitNewDiagnosis}